import type {
	ListPaymentLinksParams,
	PaymentLink,
	PaymentLinkParams,
	PaymentLinksPagination,
} from "src/types";
import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

const paymentLinkProvider = {
	async listPaymentLinks(
		merchantId: string,
		params?: ListPaymentLinksParams,
	): Promise<PaymentLinksPagination> {
		// Clean up undefined/empty params
		const cleanParams = params
			? Object.fromEntries(
					Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
				)
			: undefined;
		const response = await apiRequest.get(
			withApiPath(`/merchant/${merchantId}/payment-link`),
			{ params: cleanParams },
		);
		return response.data;
	},

	async createPaymentLink(
		merchantId: string,
		params: PaymentLinkParams,
	): Promise<PaymentLink> {
		const response = await apiRequest.post(
			withApiPath(`/merchant/${merchantId}/payment-link`),
			params,
		);
		return response.data;
	},

	async getPaymentLink(
		merchantId: string,
		paymentLinkId: string,
	): Promise<PaymentLink> {
		const response = await apiRequest.get(
			withApiPath(`/merchant/${merchantId}/payment-link/${paymentLinkId}`),
		);
		return response.data;
	},

	async deletePaymentLink(
		merchantId: string,
		paymentLinkId: string,
	): Promise<void> {
		await apiRequest.delete(
			withApiPath(`/merchant/${merchantId}/payment-link/${paymentLinkId}`),
		);
	},
};

export default paymentLinkProvider;
